interface CapsuleAudioControlsProps {
  audioPlaying: boolean;
  audioReady: boolean;
  onPlay: () => void;
  onPause: () => void;
  onStop: () => void;
  offset: number;
}

export function CapsuleAudioControls({
  audioPlaying,
  audioReady,
  onPlay,
  onPause,
  onStop,
  offset,
}: CapsuleAudioControlsProps) {
  return (
    <div className="capsule-audio-controls">
      <span className="capsule-controls-text">Audio available</span>
      <button
        onClick={audioPlaying ? onPause : onPlay}
        disabled={!audioReady}
        className={`capsule-btn ${audioPlaying ? 'capsule-btn--warning' : 'capsule-btn--primary'}`}
      >
        {audioPlaying ? 'Pause Audio' : 'Play with Audio'}
      </button>
      {audioPlaying && (
        <button onClick={onStop} className="capsule-btn capsule-btn--ghost">
          Stop
        </button>
      )}
      {offset !== 0 && (
        <span className="capsule-controls-text">
          (offset: {offset > 0 ? '+' : ''}{offset}ms)
        </span>
      )}
    </div>
  );
}
